import React, { FunctionComponent, useState } from 'react'
import { css } from '@emotion/css'
import { backgroundColor } from '../../../theme'
import { Button } from 'antd'
import { MenuOutlined } from '@ant-design/icons'
import MainMenu from '../MainMenu/MainMenu'
import { Layout } from 'antd'
import { atText } from '../../../assets/logos'

const { Sider } = Layout

interface IProps {
  selectedKey: string
  setSelectedKey: (key: string) => void
}

const HomeMenu: FunctionComponent<any> = (props: IProps) => {
  const [collapsed, setCollapsed] = useState(true)
  const { setSelectedKey, selectedKey } = props

  return (
    <Sider
      css={css`
        background-color: ${backgroundColor} !important;
        z-index: 3;
      `}
      trigger={null}
      collapsible={true}
      collapsed={collapsed}
      onCollapse={(value) => setCollapsed(value)}
      width={300}
    >
      <div
        id={'menu-logo'}
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: collapsed ? 'center' : 'space-evenly',
          alignItems: 'center',
          padding: '10px'
        }}
      >
        {collapsed ? null : atText({ width: '200px' })}
        <Button size={'large'} icon={<MenuOutlined />} onClick={() => setCollapsed(!collapsed)} />
      </div>
      <MainMenu setSelectedKey={setSelectedKey} selectedKey={selectedKey} collapsed={collapsed} />
    </Sider>
  )
}

export default HomeMenu
